// extracted by mini-css-extract-plugin
export var chevron = "_2v-2";
export var chevronCollapsed = "_2v-3";
export var collapsibleHeader = "_2v-1";
export var container = "_2v-0";